
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 576 512","stroke":"currentColor","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M288 176c26.48 0 48-21.52 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm0-80c17.64 0 32 14.36 32 32s-14.36 32-32 32-32-14.4-32-32 14.4-32 32-32zm-18.9 230.1c4.3 6.2 11.3 9.9 18.9 9.9s14.62-3.703 18.91-9.906c16.12-23.38 29.91-43.03 41.72-59.81C403.1 188.7 416 170.3 416 128 416 57.42 358.59 0 288 0S160 57.42 160 128c0 42.3 12.94 60.73 67.38 138.3 11.82 16.8 24.72 36.4 41.72 59.8zM288 16c61.75 0 112 50.25 112 112 0 37.25-9.844 51.27-64.5 129.1-11.8 16.8-25.6 36.5-41.8 59.9-2.625 3.812-8.812 3.812-11.44 0-16.16-23.42-30-43.11-41.78-59.91C185.8 179.3 176 165.3 176 128c0-61.75 50.3-112 112-112zm284.6 145.4a7.884 7.884 0 00-7.344-.938l-152 56c-4.125 1.517-6.25 6.126-4.719 10.27s6 6.313 10.28 4.735L560 179.5v255l-152 57.91V328c0-4.422-3.594-8-8-8s-8 3.578-8 8v165.4l-208-59.43V328c0-4.4-3.6-8-8-8s-8 3.578-8 8v106.5L16 492.4V229.5l122.8-46.06c4.1-1.54 6.2-6.14 4.7-10.24-1.6-4.2-6.2-6.3-10.3-4.7l-128 48C2.063 217.7 0 220.7 0 224v280a7.983 7.983 0 003.469 6.594A8.162 8.162 0 008 512c.969 0 1.938-.172 2.844-.531l165.5-63.05 221.4 63.27c1.625.453 3.438.406 5.031-.219l168-64C573.9 446.3 576 443.3 576 440V168c0-2.6-1.3-5.1-3.4-6.6z"}})])
          )
        }
      }
    